export default __webpack_public_path__ + "static/media/MAMZN-UST.84d56434.svg";